import React, { FC } from 'react';

export const UnexpectedErrorIllustration: FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="500"
      height="500"
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M335.5 409.4H165.2C124.5 409.4 91.2998 376.2 91.2998 335.3V164.7C91.2998 123.9 124.5 90.6001 165.2 90.6001H335.4C376.1 90.6001 409.3 123.8 409.3 164.7V335.3C409.4 376.2 376.2 409.4 335.5 409.4Z"
        fill="#EFF2F4"
      />
      <path
        d="M314.9 289.5L388.2 388.1C395.1 397.4 393.1 410.5 383.7 417.3L380.8 419.4C371.4 426.2 358.2 424 351.6 414.4L281 313.5"
        fill="#F7C6CC"
      />
      <path
        d="M297.1 336.3C297.1 336.3 318.6 327.4 331.3 311.5L321.5 298.4L287.7 323L297.1 336.3Z"
        fill="#ED9FAC"
      />
      <path
        d="M249.7 324.4C304.266 324.4 348.5 280.166 348.5 225.6C348.5 171.034 304.266 126.8 249.7 126.8C195.135 126.8 150.9 171.034 150.9 225.6C150.9 280.166 195.135 324.4 249.7 324.4Z"
        fill="#EFF2F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M249.7 136.305C200.384 136.305 160.405 176.283 160.405 225.6C160.405 274.916 200.384 314.895 249.7 314.895C299.017 314.895 338.996 274.916 338.996 225.6C338.996 176.283 299.017 136.305 249.7 136.305ZM141.396 225.6C141.396 165.785 189.885 117.295 249.7 117.295C309.515 117.295 358.005 165.785 358.005 225.6C358.005 285.415 309.515 333.905 249.7 333.905C189.885 333.905 141.396 285.415 141.396 225.6Z"
        fill="#F7C6CC"
      />
      <path
        d="M249 282.6C254.965 282.6 259.8 277.765 259.8 271.8C259.8 265.835 254.965 261 249 261C243.036 261 238.2 265.835 238.2 271.8C238.2 277.765 243.036 282.6 249 282.6Z"
        fill="#FF2B85"
      />
      <path
        d="M270.2 226.5C273.2 224.5 276.9 221.5 280.2 217.5C289.9 205.7 288.3 194.6 284.5 186.8C280.4 178.2 267 169.6 249.1 170.8C223.9 172.6 214.6 191.3 214.9 202.1C215 206.9 218.5 210.8 223.3 211.1C228.1 211.4 232.9 208.4 233.2 203.6C233.2 203 235.2 189.6 250.3 188.3C259.4 187.5 265.1 191.2 266.8 194.5C266.8 194.5 270.4 201.1 265.7 206.8C263.6 209.3 261.8 210.8 259.3 212.7L252.6 218.3C238.5 232.7 241 246.9 241 246.9C241.4 251.8 244.9 255.7 249.8 255.7C254.7 255.7 258.5 251.8 258.5 246.9V244.1C258.9 240.4 259.5 236.3 263.4 232C263.5 232.2 268.2 227.9 270.2 226.5Z"
        fill="#FF2B85"
      />
    </svg>
  );
};
